import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";
import { ReactSelectOption } from "../../models/generic/ReactSelectOption";
import { NavListItem } from "../../models/adminNav";

export interface NavSeparatorEditData {
    id: number;
    active: boolean;
    afterItemId: ReactSelectOption | NavListItem | null;
}

export class NavSeparatorEdit implements FormValidationModel<NavSeparatorEditData> {
    public data: NavSeparatorEditData;
    public rules: yup.Schema<NavSeparatorEditData>;

    public constructor() {
        this.data = {
            id: 0,
            active: true,
            afterItemId: null,
        };
        this.rules = yup.object<NavSeparatorEditData>().shape({
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            active: yup.bool(),
            afterItemId: ReactSelectOptionSchema.label("Add separator after").required(),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminNav/NavSeparatorEdit.ts